export default __webpack_public_path__ + "static/media/lUPUS IN FABULA (1).1c3a13af.jpg";